import React, { memo } from "react";
import Carousel from "react-native-looped-carousel";
import { StyleSheet, View, Image } from "react-native";
import LinearGradient from "react-native-linear-gradient";
import color from "@constants/color";
import { scale } from "@utils/scale";
import CustomText from "@components/CustomText";

const NewCustomerCarousel = memo(({ newCxPriorityInfo = [] }) => {
  const carouselItems = (
    { title = "", icon = "", description = "" },
    index,
  ) => {
    return (
      <View style={styles.carouselItemsContainer} index={`${index}`}>
        <Image
          style={
            index === 0
              ? styles.firstIconStyle
              : index === 1
                ? styles.secondIconStyle
                : styles.thirdIconStyle
          }
          source={{ uri: icon }}
        />
        <View
          style={[
            styles.textContainer,
            {
              marginStart: index === 1 ? 10 : 0,
            },
          ]}
        >
          <CustomText style={styles.titleStyle} newfont variant="title_20">
            {title}
          </CustomText>
          <CustomText
            style={styles.descriptionStyle}
            newfont
            variant="body_text_3"
          >
            {description}
          </CustomText>
        </View>
      </View>
    );
  };

  return (
    <Carousel
      bullets={true}
      bulletStyle={[styles.buttonStyle, { width: 4 }]}
      chosenBulletStyle={[
        styles.chosenBulletStyle,
        {
          width: 16,
        },
      ]}
      bulletsContainerStyle={[styles.buttonContainerStyle, { width: "100%" }]}
      style={styles.caraousel}
      delay={4000}
      pageInfo={false}
      autoplay={true}
    >
      {newCxPriorityInfo.map(carouselItems)}
    </Carousel>
  );
});

const NewCustomerPriorityInfoWidget = memo(
  ({ showBottomLine = true, newCxPriorityInfo = [] }) => {
    return Array.isArray(newCxPriorityInfo) &&
      newCxPriorityInfo.length !== 0 ? (
      <LinearGradient
        colors={[color.dark_green, color.plain_green]}
        style={styles.gradientContainer}
        useAngle={true}
        angle={90}
      >
        <Image
          resizeMode={"contain"}
          style={styles.topImage}
          source={require("../../assets/images/top.png")}
        />
        <NewCustomerCarousel newCxPriorityInfo={newCxPriorityInfo} />
        {showBottomLine ? (
          <Image
            resizeMode={"contain"}
            style={styles.bottomImage}
            source={require("../../assets/images/bottom.png")}
          />
        ) : null}
      </LinearGradient>
    ) : null;
  },
);

export { NewCustomerCarousel, NewCustomerPriorityInfoWidget };

const styles = StyleSheet.create({
  caraousel: {
    height: scale(180),
    width: "100%",
  },
  carouselItemsContainer: {
    flexDirection: "row",
    marginVertical: 16,
    marginEnd: 5,
    flex: 1,
  },
  buttonContainerStyle: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    bottom: scale(-16),
  },
  chosenBulletStyle: {
    height: 5,
    backgroundColor: color.white,
    marginHorizontal: 3,
  },
  buttonStyle: {
    height: 5,
    backgroundColor: "rgba(255,255,255, 0.6)",
    borderRadius: 50,
    marginHorizontal: 3,
    borderWidth: 0,
  },
  firstIconStyle: {
    width: scale(160),
    height: scale(150),
  },
  secondIconStyle: {
    width: scale(140),
    height: scale(230),
  },
  thirdIconStyle: {
    width: scale(162),
    height: scale(180),
  },
  textContainer: {},
  titleStyle: {
    color: color.white,
    maxWidth: scale(200),
    lineHeight: 26,
  },
  descriptionStyle: {
    color: color.white,
    maxWidth: scale(200),
    marginTop: 8,
  },
  gradientContainer: {
    width: "100%",
    height: scale(200),
  },
  topImage: {
    width: "100%",
    position: "absolute",
    top: 0,
    height: scale(62),
  },
  bottomImage: {
    width: "100%",
    position: "absolute",
    bottom: 0,
    height: scale(75),
  },
});
